export const PORTRAIT_W = 720;
export const PORTRAIT_H = 1280;
export const WIDE_W = 1440;
export const WIDE_H = 900;
/** Wider than this, the glen leaves the phone column. */
export const WIDE_ASPECT = 1.2;

export type StageMode = 'portrait' | 'wide';

export interface Stage {
  mode: StageMode;
  w: number;
  h: number;
}

export function stageFor(width: number, height: number, touch = false): Stage {
  // A phone stays on the portrait glen even if the page opens sideways.
  if (touch) return { mode: 'portrait', w: PORTRAIT_W, h: PORTRAIT_H };
  if (height > 0 && width / height >= WIDE_ASPECT) return { mode: 'wide', w: WIDE_W, h: WIDE_H };
  return { mode: 'portrait', w: PORTRAIT_W, h: PORTRAIT_H };
}

function readWindow(): Stage {
  if (typeof window === 'undefined') return stageFor(PORTRAIT_W, PORTRAIT_H);
  const touch = (navigator.maxTouchPoints ?? 0) > 0 || 'ontouchstart' in window;
  return stageFor(window.innerWidth, window.innerHeight, touch);
}

/** Chosen once, when the page boots. Scenes and the HUD share it. */
export const stage: Stage = readWindow();
